import React, {Component} from 'react';
import SideBar from '../components/sideBar/index';
//import {mapState} from '../../state/map';
import {FilterState, SHOW_FILTERS_CHANGE_EVENT} from './state';
import {FiltersIcon} from '../components/icons/index';

import DataYear from './dataYear/container';
import Types from './types/container';
import Autonomy from './autonomy/container';
import Classes from './classes/container';
import Language from './language/container';
import reducer from '../schoolMenu/reducer';

import MenuSectionComponent  from '../components/menu/menusection';
import { connect } from 'react-redux';
import {updateViewPadding} from '../map/actions';

import { cyan } from '@material-ui/core/colors';

class Filters extends Component {
	
	handlerEvent(status) {

		if(!status){

			this.props.clickItem([null, 256, null, null]);
		} else {

			this.props.clickItem([null, 0, null, null]);
		}
		
	}
	render() {

		var {years, types, language, classes, municipality, enabled} = this.props;

		if(!enabled) {
			return null;
		}

		return (
			<SideBar pos="right" toggleCallback={this.handlerEvent.bind(this)} width={256} 
					style={{
						backgroundColor: 'rgba(255, 255, 255, 0.8)',
						padding: '5px 0 0 0'
					}}
				>
				<div style={{padding: '8px 8px 10px 8px', display: 'flex', backgroundColor: cyan[500]}}>
					<FiltersIcon style={{width: '28px'}} />
					<div style={{padding: '7px 0 0 10px', fontSize: '14px', color: 'white'}}>Informācijas filtri</div>
				</div>
				{years ? (<DataYear />) : ''}
				{types ? (<Types />) : ''}
				<hr />
				{language ? (<Language />) : ''}
				<hr />
				{classes ? (<Classes />) : ''}
				<hr />
				{municipality ? (<Autonomy />) : ''}
				<hr />
			</SideBar>
		);
	}

}



const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: (space) => {
      dispatch(updateViewPadding(space));
    }
  }
}

const mapStateToPropsRes = (state) => {

	let years = false,
		types = false,
		language = false,
		classes = false,
		municipality = false;
	

	let activeIDs = reducer.getActiveIds(state.schoolMenu);
	
	if(activeIDs.length == 1 && activeIDs.indexOf('middle_school_model') > -1) {

	} else if(activeIDs.length >= 1 && activeIDs.indexOf('school_types') > -1) {

		years = true;
		types = true;
		language = true;
		classes = true;
		municipality = true;

	} else if(activeIDs.length >= 1) {

		years = true;
		types = true;
		language = false;
		municipality = true;
	}

	let enabled;
	if(!years && !types && !language && !municipality) {

		enabled = false;
	} else {

		enabled = true;
	}

	return {
		enabled: enabled, 
		years: years,
		types: types,
		language: language,
		classes: classes,
		municipality: municipality
	}
}

const FiltersContainer = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Filters);


export default FiltersContainer;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/container.js